module.exports = __webpack_public_path__ + "img/1080_09.84420878.jpg";